var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBestHourGray = function SvgBestHourGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.997,
    height: 28,
    x: 0.502,
    fill: "#757D86",
    rx: 13.998
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.155 13.149-2.818 2.46.844 3.662a1 1 0 0 1-1.49 1.084l-3.193-1.937-3.187 1.937a1 1 0 0 1-1.49-1.084l.843-3.658-2.819-2.464a1 1 0 0 1 .57-1.754l3.715-.322 1.45-3.46a.997.997 0 0 1 1.84 0l1.455 3.46 3.714.322a1 1 0 0 1 .569 1.754z"
  })));
};
export default SvgBestHourGray;